import { ErrorWithTranslationKey } from "utils/getSafeErrorMessage";

import UserFriendlyAPIError from "services/environment/UserFriendlyAPIError";
import { systemEngineEnvironment } from "services/environment/systemEngine";
import { EMPTY_NETWORK_POLICY } from "services/serviceAccounts/types";

import { getLogins } from "./getLogins";
import { Login, LoginForUpdate } from "./login.types";

export const getCreateLoginStatement = ({
  loginName,
  firstName,
  lastName,
  isPasswordEnabled,
  isOrganizationAdmin,
  isMfaEnabled,
  networkPolicyName,
}: Partial<LoginForUpdate>) => {
  const queryParts = [
    `CREATE LOGIN "${loginName}" WITH`,
    `FIRST_NAME = e?`,
    `LAST_NAME = e?`,
    ...(networkPolicyName === EMPTY_NETWORK_POLICY || !networkPolicyName
      ? []
      : [`NETWORK_POLICY = "${networkPolicyName}"`]),
    `IS_PASSWORD_ENABLED = ?`,
    `IS_MFA_ENABLED = ?`,
    `IS_ORGANIZATION_ADMIN = ?;`,
  ];

  const sql = systemEngineEnvironment.formatter.formatQuery(
    queryParts.join("\n"),
    [firstName, lastName, isPasswordEnabled, isMfaEnabled, isOrganizationAdmin]
  );
  return sql;
};

export const createLogin = async (
  options: Partial<LoginForUpdate>
): Promise<Login> => {
  const { loginName } = options;
  try {
    const sql = getCreateLoginStatement(options);
    await systemEngineEnvironment.execute(sql);

    const logins = await getLogins(loginName);

    if (!logins.length) {
      throw new ErrorWithTranslationKey("logins.form.create.error");
    }

    return logins[0];
  } catch (e) {
    if (e instanceof UserFriendlyAPIError) {
      throw e;
    }

    throw new ErrorWithTranslationKey("logins.form.create.error");
  }
};
